module.exports = __webpack_public_path__ + "img/idcard_invite.aa56bb12.svg";